<template>
  <div>
    <p class="mt-3 d-none d-md-block">
      {{ bio }}
    </p>
    <div
      class="bio-container d-md-none"
      :class="{ expanded: !isCollapsed }"
      @click="isCollapsed = !isCollapsed"
      @keydown.enter="isCollapsed = !isCollapsed"
      @keydown.space.prevent="isCollapsed = !isCollapsed"
      tabindex="0"
      role="button"
    >
      <p class="speaker-bio">{{ bio }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpeakerBio",
  props: {
    bio: { type: String, required: true },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
};
</script>

<style scoped lang="scss">
.bio-container {
  position: relative;
  background: #fff; /* match your page */
  cursor: pointer; /* indicates it’s interactive */
}

/* clamp to ~3 lines (3 × 1.5em) when collapsed */
.speaker-bio {
  margin: 1rem 0;
  line-height: 1.5;
  max-height: 4.5em; /* 3 lines × 1.5em */
  overflow: hidden;
  transition: max-height 0.3s ease;
}

/* remove the clamp when “expanded” */
.bio-container.expanded .speaker-bio {
  max-height: none;
}

/* fade‐out overlay at the bottom of the <p> */
.speaker-bio::after {
  content: "";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4.5em; /* height of three lines */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

/* hide the fade once expanded */
.bio-container.expanded .speaker-bio::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FadingSpeakerBio.vue